import { render } from "./Equipe.vue?vue&type=template&id=039fdc4a"
import script from "./Equipe.vue?vue&type=script&lang=js"
export * from "./Equipe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__